import type Parse from 'parse';

import { ILicenseInfo, License } from '@telespot/domain';
import { ParseMapper } from '../../parse.mapper';

export enum LicenseTopology {
  TABLE = 'License',
  NAME = 'name',
  INFO = 'info',
}

export class ParseLicenseMapper extends ParseMapper {
  public toDomain(parseObject: Parse.Object): License {
    return new License({
      name: parseObject.get(LicenseTopology.NAME),
      info: parseObject.get(LicenseTopology.INFO) as ILicenseInfo,
    });
  }
}
